import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import type { Property } from 'csstype';

import { shouldForwardProps } from '../utils';

const Center = styled(Box, shouldForwardProps)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;
const FlexBox = styled(Box, shouldForwardProps)`
    display: flex;
    width: 100%;
    height: 100%;
`;
const Row = styled(Box, shouldForwardProps)<{ stretch?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: ${({ stretch }) => (stretch ? 'space-between' : 'flex-start')};
    align-items: center;
`;

const Column = styled(Box, shouldForwardProps)`
    display: flex;
    flex-direction: column;
`;

const GridRow = styled(Grid)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

interface WrapContainerProps {
    justifyContent?: Property.JustifyContent;
    alignItems?: Property.AlignItems;
}

const WrapContainer = styled(Box, shouldForwardProps)<WrapContainerProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent = 'flex-end' }) => justifyContent};
    align-items: ${({ alignItems = 'center' }) => alignItems};
`;

export { FlexBox, Center, Column, Row, GridRow, WrapContainer };
